// InformationSection.jsx
import { Helmet } from 'react-helmet';
import Faq from './Faq';
import '../styles/InformationSection.css';

function InformationSection() {
  return (
    <section id="information" aria-labelledby="info-heading" itemScope itemType="https://schema.org/LocalBusiness">
      <Helmet>
        <title>Info & FAQ | Lu - Fit Personal Training in Cape Town</title>
        <meta
          name="description"
          content="Get all the key information about our operating hours, cancellation policies, and training terms. Find answers to frequently asked questions."
        />
        <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "name": "Lu - Fit",
              "description": "Certified personal trainer based in Cape Town offering 1-on-1 and group sessions",
              "openingHours": [
                "Mo-Fr 05:00-21:00",
                "Sa 07:00-16:30"
              ],
              "areaServed": "Cape Town, Western Cape",
              "url": "https://yourwebsite.com"
            }
          `}
        </script>
      </Helmet>
      <header>
        <h2 id="faq-subheading">Frequently Asked Questions</h2>
        <p className="faq-subheading-text">
          Everything you need to know about training with Lu - Fit in Cape Town — from booking to workouts and more.
        </p>
      </header>
      <div className="information-wrapper">
        <div className="faq-wrapper">
          <Faq />
        </div>
        
        <div className="information-container">
          <div className="info-card" role="region" aria-labelledby="hours-heading">
            <h2 id="hours-heading">Operating Hours</h2>
            <ul className="info-list">
              <li><strong>Sunday:</strong> <span>Closed</span></li>
              <li><strong>Monday – Friday:</strong> <span>05:00 – 21:00</span></li>
              <li><strong>Saturday:</strong> <span>07:00 – 16:30</span></li>
            </ul>
          </div>

          <div className="info-card" role="region" aria-labelledby="cancellation-heading">
            <h2 id="cancellation-heading">Cancellation Policy</h2>
            <p>
              We understand life happens. However, to ensure fairness and scheduling efficiency, we require at least <strong>24 hours’ notice</strong> for cancellations. Late cancellations may result in forfeited sessions.
            </p>
          </div>

          <div className="info-card" role="region" aria-labelledby="policies-heading">
            <h2 id="policies-heading">Training Policies</h2>
            <p>
              Sessions and packages are <strong>non-refundable</strong> and must be used within the purchased month. Unused sessions <strong>do not carry over</strong>.
            </p>
          </div>
        </div>
      </div>  
    </section>
  );
}

export default InformationSection;
